import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useLanguage } from "@/contexts/LanguageContext";

interface SiteContent {
  [key: string]: string;
}

export const useSiteContent = (section: string) => {
  const { language } = useLanguage();
  const [content, setContent] = useState<SiteContent>({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      setIsLoading(true);
      const { data, error } = await supabase
        .from('site_content')
        .select('content_key, content_value')
        .eq('section', section)
        .eq('language', language);

      if (!error && data) {
        const contentMap: SiteContent = {};
        data.forEach(item => {
          contentMap[item.content_key] = item.content_value;
        });
        setContent(contentMap);
      }
      setIsLoading(false);
    };

    fetchContent();

    // Subscribe to realtime updates
    const channel = supabase
      .channel(`site-content-${section}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'site_content',
          filter: `section=eq.${section}`
        },
        () => {
          fetchContent();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [section, language]);

  return { content, isLoading };
};
